import locale from 'meta-ui/lib/locale/lang/pt';
import pt from 'govmo-common/src/locales/pt.json';
import merge from 'lodash/merge';
import DataComponent from 'common/components/Data/locales/pt.json';
import MessagePluginComponent from 'common/plugins/message/locales/pt.json';

export default {
  ...MessagePluginComponent,
  ...DataComponent,
  ...merge(locale, {
    el: {
      transfer: {
        filterPlaceholder: '請輸入搜索內容',
      },
    },
  }),
  ...pt,
};
